export default "__VITE_ASSET__DsjpBd1h__"